/**
 * Special body for Group Audit: FormBodyID 179.
 */

import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {GALinkStatus, GAFormCategory, documentTypes, ExpandValues} from '../../../../../../../../util/uiconstants';

import LoadingIndicator from '../../../../../../LoadingIndicator/LoadingIndicator';
import SpecialBodyWrapper from '../Common/SpecialBodyWrapper';
import InvolvementSummary from './InvolvementSummary';

import {
	getAllComponents,
	cleanComponentsAndFormActions
} from '../../../../../../../../actions/GroupAudit/GroupComponents';
import {getFormActions} from '../../../../../../../../actions/Form/formactions';
import {getEntityDocuments} from '../../../../../../../../actions/Document/entityDocumentActions';

export default function GroupInvolvementSummary({...specialBodyProps}) {
	const engagementId = useSelector(({engagementId}) => engagementId);
	const components = useSelector(({groupAudit}) => groupAudit?.components?.data);
	const formActions = useSelector(({formActions}) => formActions);
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);
	const [isFormActionApiCallCompleted, setIsFormActionApiCallCompleted] = useState(false);

	useEffect(() => {
		setIsLoading(true);
		dispatch(getEntityDocuments(engagementId, documentTypes.GROUP_INVOLVEMENT_INDIVIDUAL_COMPONENT)).finally(() => {
			setIsLoading(false);
		});
	}, []);

	/* -The group involvement table needs the information that comes from the api everytime the component it's 
	 	rendered due to it's the most up to date, cleaning the state is a must in order work properly.
	   -NOTE: Cheking or uncheking available actions from /Group Involvement Index /Component /Form Document does not
	    use the same state chunk, hence there is not correspondency from what is used there and what is used here.
	   -TODO: The whole process needs to be analyzed in-depth and refactored if we want to mantain the correct state of 
	   	'Selected Actions' in the UI
	*/
	useEffect(() => {
		setIsLoading(true);
		dispatch(cleanComponentsAndFormActions()).then(() => {
			dispatch(getAllComponents(engagementId)).finally(() => {
				setIsLoading(false);
			});
		});
	}, []);

	useEffect(() => {
		if (components !== null && !isFormActionApiCallCompleted) {
			setIsLoading(true);
			dispatch(
				getFormActions(engagementId, GAFormCategory.GroupInvolvement, null, true, true, false, undefined)
			).finally(() => {
				setIsFormActionApiCallCompleted(true);
				setIsLoading(false);
			});
		}
	}, [components]);

	const renderInvolvementSummary = () => {
		const props = {
			components: components?.filter((c) => c.linkRequest !== GALinkStatus.ReferenceOnly),
			formActions,
			isLoading
		};

		return (
			<>
				<InvolvementSummary {...props} />
			</>
		);
	};

	return (
		<SpecialBodyWrapper {...specialBodyProps}>
			{isLoading && <LoadingIndicator view="inlineView" />}
			{!isLoading && isFormActionApiCallCompleted && renderInvolvementSummary()}
		</SpecialBodyWrapper>
	);
}

GroupInvolvementSummary.propTypes = {};
GroupInvolvementSummary.defaultProps = {};
